import React, { forwardRef } from 'react';
import { StyledRangeHandle } from './styles';

export interface RangeHandleProps {
  disabled?: boolean;
  id?: string;
  index?: number;
  min?: number;
  max?: number;
  label: string;
  size?: number;
  value?: number;
  describedBy?: string;
  error?: string | string[];
}

const RangeHandle = forwardRef<HTMLDivElement, RangeHandleProps>(
  ({ disabled, id, index, min, max, value, label, size = 20, error, describedBy }, ref) => {
    return (
      <StyledRangeHandle
        id={id}
        size={size}
        className='slider-handle'
        ref={ref}
        role='slider'
        data-index={index}
        data-value={value}
        tabIndex={disabled ? -1 : 0}
        aria-disabled={disabled}
        aria-valuemin={min}
        aria-valuenow={value}
        aria-valuemax={max}
        aria-label={label}
        aria-describedby={describedBy}
        aria-invalid={!!error}
      />
    );
  }
);

export default RangeHandle;
